/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

 function updateSubscriptionFreeShippingMessage() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const hasSubscription = cart.items.some(item => item.selling_plan_allocation);

        if (!hasSubscription) return;

        const cartMessage = document.querySelector('[data-cart-message]');
        const defaultMessage = document.querySelector('[data-message-default]');
        const progressBars = document.querySelectorAll('[data-cart-message-progress]');

        if (!cartMessage) return;

        cartMessage.classList.add('is-success');

        if (defaultMessage) {
          defaultMessage.classList.add('is-hidden');
        }

        progressBars.forEach(bar => {
          bar.value = 100;
          bar.style.setProperty('--progress-width', '100%');
        });
      });
  }

  document.addEventListener('DOMContentLoaded', updateSubscriptionFreeShippingMessage);
  document.addEventListener('cart:updated', updateSubscriptionFreeShippingMessage);
  document.addEventListener('theme:cart:change', updateSubscriptionFreeShippingMessage);

  setInterval(updateSubscriptionFreeShippingMessage, 1000);





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
